import React, { useState } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderTextField, renderselect } from "../../../../Components/Forms/renders";
import SwitcButton from "../../../../Components/Forms/switch";
import TimeSelect from "../../../../Components/Forms/time";
import MultiSelectDagen from "../../../../Components/Forms/multiselect";

const InsertForm = ({ handleSubmit }) => {
  const [activeTab, setActiveTab] = useState('algemeen');

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          {/* TABS NAVIGATIE */}
          <ul className="nav nav-tabs mb-4" role="tablist">
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab === 'algemeen' ? 'active' : ''}`}
                onClick={() => setActiveTab('algemeen')}
                role="tab"
                style={{ cursor: 'pointer' }}
              >
                <i className="fa fa-info-circle"></i> Algemeen
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab === 'stroom' ? 'active' : ''}`}
                onClick={() => setActiveTab('stroom')}
                role="tab"
                style={{ cursor: 'pointer' }}
              >
                <i className="fa fa-bolt"></i> Stroom & Tarieven
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab === 'betalingen' ? 'active' : ''}`}
                onClick={() => setActiveTab('betalingen')}
                role="tab"
                style={{ cursor: 'pointer' }}
              >
                <i className="fa fa-credit-card"></i> Betalingen
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab === 'app' ? 'active' : ''}`}
                onClick={() => setActiveTab('app')}
                role="tab"
                style={{ cursor: 'pointer' }}
              >
                <i className="fa fa-mobile-alt"></i> App & Kiosk
              </a>
            </li>
          </ul>

          {/* TAB CONTENT */}
          <div className="tab-content">
            {/* ALGEMEEN TAB */}
            {activeTab === 'algemeen' && (
              <div className="tab-pane active">
                <div className="row">
                  <div className="col-md-8">
                    <Field name="naam" type="input" validate={[required()]} component={renderField} label="Naam Gasten profiel" />
                    <Field name="beschrijving" type="input" component={renderTextField} label="Beschrijving profiel (optioneel)" />
                    <Field name="isStandaard" type="input" component={SwitcButton} label="Dit is het standaard profiel" />
                    <Field 
                      name="standplaatsCategorie" 
                      component={renderselect} 
                      label="Gekoppelde Standplaats Categorie (optioneel)" 
                      options={{
                        '': 'Geen categorie gekoppeld',
                        // Hier zouden de categorien moeten komen
                      }}
                    />
                    <Field 
                      name="precedence" 
                      component={renderselect} 
                      label="Prioriteit bij conflicten" 
                      options={{
                        'gast': 'Gast instellingen hebben voorrang',
                        'categorie': 'Categorie instellingen hebben voorrang'
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <Field name="minaantaldagen" type="input" component={renderField} label="Minimaal aantal dagen" />
                    <Field name="inchecktijd" type="number" component={TimeSelect} label="Check-in tijd" />
                    <Field name="uitchecktijd" type="number" component={TimeSelect} label="Check-out tijd" />
                    <Field name="autouitcheck" type="input" component={SwitcButton} label="Automatische uitcheck" />
                  </div>
                </div>
              </div>
            )}

            {/* STROOM & TARIEVEN TAB */}
            {activeTab === 'stroom' && (
              <div className="tab-pane active">
                <div className="row">
                  <div className="col-md-6">
                    <h5><i className="fa fa-euro-sign"></i> Tarieven</h5>
                    <Field name="prijs" type="number" component={renderField} label="Prijs per kWh (€)" />
                    <Field name="minimaalkwh" type="number" component={renderField} label="Minimaal aantal kWh per boeking" />
                    <Field name="kwkinclusief" type="number" component={renderField} label="Inclusief kWh per dag" />
                  </div>
                  <div className="col-md-6">
                    <h5><i className="fa fa-bolt"></i> Stroom Instellingen</h5>
                    <Field name="instellenkwh" type="input" component={SwitcButton} label="kWh instelling verplicht" />
                    <Field name="instellenamp" type="input" component={SwitcButton} label="Ampères kunnen worden ingesteld" />
                    <Field name="afwijkingAmpere" type="number" component={renderField} label="Toegestane ampèrage afwijking" />
                    <Field name="schakelen.in" type="input" component={SwitcButton} label="Gasten mogen stroom inschakelen" />
                    <Field name="schakelen.uit" type="input" component={SwitcButton} label="Gasten mogen stroom uitschakelen" />
                    <Field name="sendalert" type="input" options={[50, 60, 70, 80, 90]} component={MultiSelectDagen} label="Meldingen bij verbruik (%)" />
                  </div>
                </div>
              </div>
            )}

            {/* BETALINGEN TAB */}
            {activeTab === 'betalingen' && (
              <div className="tab-pane active">
                <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-6">
                        <h5><i className="fa fa-mobile-alt"></i> App Betalingen</h5>
                        <Field name="app.betalen" type="input" component={SwitcButton} label="Betaling via app mogelijk" />
                        <Field 
                          name="app.betaalmethode" 
                          component={renderselect} 
                          label="App Betaalmethode" 
                          options={{
                            'mollie': 'Mollie',
                            'paynl': 'Pay.nl'
                          }}
                        />
                      </div>
                      <div className="col-md-6">
                        <h5><i className="fa fa-desktop"></i> Kiosk Betalingen</h5>
                        <Field name="kiosk.betalen" type="input" component={SwitcButton} label="Betaling via kiosk mogelijk" />
                        <Field 
                          name="kiosk.betaalmethode" 
                          component={renderselect} 
                          label="Kiosk Betaalmethode" 
                          options={{
                            'mollie': 'Mollie',
                            'paynl': 'Pay.nl'
                          }}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-md-6">
                        <Field name="betalen" type="input" component={SwitcButton} label="Betaling voor stroom verplicht (legacy)" />
                        <Field name="oprekening" type="input" component={SwitcButton} label="Betaling op rekening (jaarplaatsen)" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* APP & KIOSK TAB */}
            {activeTab === 'app' && (
              <div className="tab-pane active">
                <div className="row">
                  <div className="col-md-6">
                    <h5><i className="fa fa-mobile-alt"></i> App Functionaliteit</h5>
                    <Field name="app.vertrekdatumwijzigen" type="input" component={SwitcButton} label="Vertrekdatum wijzigen" />
                    <Field name="app.uitchecken" type="input" component={SwitcButton} label="Zelf uitchecken" />
                    <Field name="app.qr" type="input" component={SwitcButton} label="QR code scannen" />
                  </div>
                  <div className="col-md-6">
                    <h5><i className="fa fa-desktop"></i> Kiosk Functionaliteit</h5>
                    <Field name="kiosk.vertrekdatumwijzigen" type="input" component={SwitcButton} label="Vertrekdatum wijzigen" />
                    <Field name="kiosk.uitchecken" type="input" component={SwitcButton} label="Zelf uitchecken" />
                    <Field name="kiosk.qr" type="input" component={SwitcButton} label="QR code scannen" />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* SUBMIT KNOP */}
          <div className="pull-left submit mt-4">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Aanmaken" />
          </div>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(
  reduxForm({
    form: "kampeerplaatscategorieinsert",
  })(InsertForm)
);
